import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsByEventIdOrByLeagueId = QueryFactory(SD.QueryTypes.GetEventsByEventIdOrByLeagueId);
//# sourceMappingURL=QGetEventsByEventIdOrByLeagueId.js.map